import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
  status: 'idle',
}

export const contactUsSlice = createSlice({
  name: 'contactUsCount',
  initialState,

  reducers: {
    setContactUsCount: (state, action) => {
        state.value = action.payload;
    },
  },
});

export const { setContactUsCount } = contactUsSlice.actions;

export const contactUsCount = (state) => state.contactUsCount.value;

export default contactUsSlice.reducer;